import React from 'react';

/**
 * SkipLink Component
 * Provides a skip navigation link for keyboard users and screen readers
 * Follows WCAG 2.1 guidelines for accessibility
 */
const SkipLink = () => {
  return (
    <a
      href="#main-content"
      className="skip-link sr-only focus:not-sr-only"
      style={{
        position: 'fixed',
        left: '-9999px',
        top: '0',
        zIndex: 10000,
        padding: '1rem 1.5rem',
        backgroundColor: '#f97316',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '0 0 0.5rem 0',
        fontWeight: '600',
        fontSize: '1rem',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
      }}
      onFocus={(e) => {
        e.target.style.left = '1rem';
        e.target.style.top = '1rem';
      }}
      onBlur={(e) => {
        e.target.style.left = '-9999px';
      }}
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
